import { useEffect, useState } from "react";

import StaticInfoCardColumn from "./StaticInfoCardColumn";

import "./staticInfoCard.scss";

const StaticInfoCardList = ({ staticInfoDataList, onCollapseSubTitle }) => {
  const [columnDataList, setColumnDataList] = useState([]);

  useEffect(() => {
    if (staticInfoDataList.length) {
      const dieTrid = [];
      const virusTotalMetadefender = [];
      const prevalanceMatchesAVDetections = [];
      const staticCapabilities = [];
      const yara = [];

      staticInfoDataList.forEach((data) => {
        if (data.title === "DiE File Type Report" || data.title === "TRiD File Type Report") {
          dieTrid.push(data);
        } else if (
          data.title === "Virustotal Classification" ||
          data.title === "Metadefender Classification"
        ) {
          virusTotalMetadefender.push(data);
        } else if (
          data.title === "Prevalance Matches" ||
          data.title === "Prevalance Match" ||
          data.title === "AV Detections" ||
          data.title === "AV Detection"
        ) {
          prevalanceMatchesAVDetections.push(data);
        } else if (data.title === "Static Capabilities") {
          staticCapabilities.push(data);
        } else if (
          data.title === "All YARA Rule Matches" ||
          data.title === "Custom YARA Rule Matches"
        ) {
          yara.push(data);
        }
      });
      setColumnDataList(
        [
          yara,
          virusTotalMetadefender,
          staticCapabilities,
          prevalanceMatchesAVDetections,
          dieTrid,
        ].filter((list) => list.length),
      );
    } else {
      setColumnDataList([]);
    }
  }, [staticInfoDataList, setColumnDataList]);

  return (
    <div className="static-info-card-list">
      {columnDataList?.map((columnList, i) => (
        <StaticInfoCardColumn
          key={i}
          staticInfoColumnDataList={columnList}
          onCollapseSubTitle={onCollapseSubTitle}
        />
      ))}
    </div>
  );
};

export default StaticInfoCardList;
